import { Field, TextField, TextAreaField, YesNoCards, OptionCards, PillGrid } from "@/components/controls";
import { POSITIONS, SHIRT_SIZES } from "@/lib/formConfig";

export default function StepAboutYou({ data, setField }) {
  return (
    <div className="space-y-7">
      <div>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">About You</h2>
        <p className="text-sm sm:text-base text-slate-600 mt-1">Tell us who you are and which role fits you best.</p>
      </div>

      <Field label="Which position are you applying for?" required testId="field-position">
        <OptionCards name="position" value={data.position} onChange={(v) => setField("position", v)} options={POSITIONS} />
      </Field>

      <Field label="First Name" required testId="field-first-name">
        <TextField testId="input-first-name" value={data.firstName} onChange={(v) => setField("firstName", v)} placeholder="First name" />
      </Field>

      <Field label="Last Name" required testId="field-last-name">
        <TextField testId="input-last-name" value={data.lastName} onChange={(v) => setField("lastName", v)} placeholder="Last name" />
      </Field>

      <Field label="Phone Number" required testId="field-phone">
        <TextField testId="input-phone" type="tel" value={data.phone} onChange={(v) => setField("phone", v)} placeholder="(555) 555-5555" />
      </Field>

      <Field label="Email Address" required hint="Email address where you will receive updates and current event details." testId="field-email">
        <TextField testId="input-email" type="email" value={data.email} onChange={(v) => setField("email", v)} placeholder="you@email.com" />
      </Field>

      <Field label="Full Address" required hint="Current address. We like to send surprise gifts from time to time. (Street, City, State, Zip)" testId="field-address">
        <TextAreaField testId="input-address" rows={3} value={data.address} onChange={(v) => setField("address", v)} placeholder="Street, City, State, Zip" />
      </Field>

      <Field label="Are you 18 or older?" required testId="field-is-18">
        <YesNoCards name="is-18" value={data.is18} onChange={(v) => setField("is18", v)} />
      </Field>

      <Field label="Are you legally authorized to work in the U.S.?" required testId="field-work-auth">
        <YesNoCards name="work-auth" value={data.workAuth} onChange={(v) => setField("workAuth", v)} />
      </Field>

      <Field label="Instagram Handle / Social Link" hint="Optional — show us your vibe! We love to see the energy you bring." testId="field-instagram">
        <TextAreaField testId="input-instagram" rows={2} value={data.instagram} onChange={(v) => setField("instagram", v)} placeholder="@yourhandle" />
      </Field>

      <Field label="What shirt size should we order so you don't end up swimming in a staff shirt?" required testId="field-shirt-size">
        <PillGrid name="shirt-size" value={data.shirtSize} onChange={(v) => setField("shirtSize", v)} options={SHIRT_SIZES} />
      </Field>
    </div>
  );
}
